// extracted by mini-css-extract-plugin
module.exports = {"list":"Social_list__3pr3Q","item":"Social_item__1ov2L","link":"Social_link__iiq4A","icon":"Social_icon__2aY6f"};